/**
 * HLF Global Countdown Timer
 * Single timer drives all countdown instances on the page.
 * Reads end-date from data attributes set by Liquid.
 */
(function () {
  'use strict';

  var IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;

  function tonightMidnightUTC() {
    var nowIST = new Date(Date.now() + IST_OFFSET_MS);
    var tomorrowIST = new Date(Date.UTC(
      nowIST.getUTCFullYear(),
      nowIST.getUTCMonth(),
      nowIST.getUTCDate() + 1
    ));
    return tomorrowIST.getTime() - IST_OFFSET_MS;
  }

  function parseFinalCutoff(dateStr) {
    if (!dateStr) return 0;
    var p = dateStr.match(/(\d{4})-(\d{2})-(\d{2})/);
    if (!p) return 0;
    return Date.UTC(+p[1], +p[2] - 1, +p[3] + 1) - IST_OFFSET_MS;
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  function updateElement(el, days, hours, minutes, seconds) {
    var style = el.getAttribute('data-countdown-style');

    if (style === 'strip') {
      updateStripElement(el, days, hours, minutes, seconds);
    } else if (style === 'card') {
      updateCardElement(el, days, hours, minutes, seconds);
    } else {
      updateCompactElement(el, days, hours, minutes, seconds);
    }
  }

  function handleDayVisibility(el, days) {
    var dayWrapper = el.querySelector('[data-unit-wrapper="days"]');
    var daySep = el.querySelector('[data-unit-sep="days"]');
    if (!dayWrapper) return;
    
    if (days > 0) {
      dayWrapper.style.display = '';
      if (daySep) daySep.style.display = '';
    } else {
      dayWrapper.style.display = 'none';
      if (daySep) daySep.style.display = 'none';
    }
  }

  /* ── Strip style (Deal of the Day) ── */
  function updateStripElement(el, d, h, m, s) {
    handleDayVisibility(el, d);
    var dEl = el.querySelector('[data-unit="days"]');
    var hEl = el.querySelector('[data-unit="hours"]');
    var mEl = el.querySelector('[data-unit="minutes"]');
    var sEl = el.querySelector('[data-unit="seconds"]');
    if (dEl) setDigits(dEl, d);
    if (hEl) setDigits(hEl, h);
    if (mEl) setDigits(mEl, m);
    if (sEl) setDigits(sEl, s);
  }

  function setDigits(container, val) {
    var digits = pad(val).split('');
    var spans = container.querySelectorAll('.hlf-cd-digit');
    digits.forEach(function (d, i) {
      if (spans[i] && spans[i].textContent !== d) {
        spans[i].textContent = d;
        spans[i].classList.remove('hlf-cd-pop');
        void spans[i].offsetWidth;
        spans[i].classList.add('hlf-cd-pop');
      }
    });
  }

  /* ── Card style (Flavour of the Day) ── */
  function updateCardElement(el, d, h, m, s) {
    handleDayVisibility(el, d);
    setFlip(el.querySelector('[data-unit="days"]'), d);
    setFlip(el.querySelector('[data-unit="hours"]'), h);
    setFlip(el.querySelector('[data-unit="minutes"]'), m);
    setFlip(el.querySelector('[data-unit="seconds"]'), s);
  }

  function setFlip(el, val) {
    if (!el) return;
    var str = pad(val);
    if (el.textContent !== str) {
      el.classList.remove('hlf-cd-flip');
      void el.offsetWidth;
      el.textContent = str;
      el.classList.add('hlf-cd-flip');
    }
  }

  /* ── Compact & Header style (product cards / header) ── */
  function updateCompactElement(el, d, h, m, s) {
    handleDayVisibility(el, d);
    var dEl = el.querySelector('[data-unit="days"]');
    var hEl = el.querySelector('[data-unit="hours"]');
    var mEl = el.querySelector('[data-unit="minutes"]');
    var sEl = el.querySelector('[data-unit="seconds"]');
    setCell(dEl, d);
    setCell(hEl, h);
    setCell(mEl, m);
    setCell(sEl, s);
  }

  function setCell(el, val) {
    if (!el) return;
    var str = pad(val);
    if (el.textContent !== str) {
      el.textContent = str;
      // Trigger tick animation if the element is a compact cell
      if (el.classList.contains('hlf-cd-compact-cell')) {
        el.classList.remove('hlf-cd-cell-tick');
        void el.offsetWidth;
        el.classList.add('hlf-cd-cell-tick');
      }
    }
  }

  /* ── Hide expired countdown + parent wrappers ── */
  function hideExpired(el) {
    if (el.getAttribute('data-hlf-expired')) return; // already handled
    el.setAttribute('data-hlf-expired', '1');
    el.style.display = 'none';

    // Walk up and hide known parent wrapper containers so the whole
    // timer area disappears cleanly (header bar, cart-drawer bar,
    // flash-sale timer-wrap, product-card countdown wrapper, etc.)
    var wrapperSelectors = [
      '.hlf-header-countdown-bar',
      '.cart-drawer__countdown-bar',
      '.hlf-fsb-timer-wrap',
      '.hlf-product-card__countdown',
      '.product-page-countdown',
      '[class*="fotd-timer-row"]'
    ];
    wrapperSelectors.forEach(function (sel) {
      var parent = el.closest(sel);
      if (parent) parent.style.display = 'none';
    });
  }

  /* ── Main tick — drives all instances ── */
  var tickIntervalId = null;

  function tick() {
    var elements = document.querySelectorAll('.hlf-countdown');
    if (!elements.length) {
      if (tickIntervalId) {
        clearInterval(tickIntervalId);
        tickIntervalId = null;
      }
      return;
    }

    var now = Date.now();

    elements.forEach(function (el) {
      if (el.style.display === 'none') el.style.display = '';
      if (el.hasAttribute('data-hlf-expired')) el.removeAttribute('data-hlf-expired');

      var endDate = el.getAttribute('data-end-date');
      var finalCutoff = parseFinalCutoff(endDate);

      var target;
      // If a specific future sale end date is set, count down to it.
      // When time has expired (or if no future date is set), reset to count down to midnight every night.
      if (finalCutoff && now < finalCutoff) {
        target = finalCutoff;
      } else {
        target = tonightMidnightUTC();
      }

      var diff = target - now;

      // When midnight is crossed, rollover immediately to the next midnight
      if (diff <= 0) {
        target = tonightMidnightUTC();
        diff = target - now;
      }

      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);

      updateElement(el, days, hours, minutes, seconds);
    });
  }

  function init() {
    tick();
    tickIntervalId = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
